/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


export default {
  //  getItem: state => (productId) => state.developmentActions.find((product) => product.id == productId),
}
